<template>
    <div style="">
        <div style="text-align: center; border-left: 1px solid #cccccc;">
<!--            <van-button size="small" icon="filter-o"-->
<!--                        @click="showChooseOptionsPage"-->
<!--                        style="height: 25px; line-height: 25px"-->
<!--            >筛选-->
<!--            </van-button>-->
            <van-button size="small" @click="showChooseOptionsPage" style="height: 39px; width: 100%;"
                        :color="has_filter ? '#EE0A24' : '#ffffff'">
                <div style="padding-left: 2px; font-weight: bold; display: inline-flex; line-height: 39px">
                    <span :style="{color: has_filter ? '#ffffff' : '#000000'}">筛选</span>
                    <div style="margin-top: 2px;">
                        <van-icon name="filter-o" :color="has_filter ? '#ffffff' : '#000000'"/>
                    </div>
                </div>

            </van-button>
        </div>
        <van-popup v-model="showPop" position="top">
<!--            <div :style="{width: ($common.screenWidth - 55) + 'px', height: $common.screenHeight + 'px'}">-->
            <div style="height: 450px">
                <div style="text-align: center; padding: 10px 0px">
                    <span style="font-size: 16px">筛选</span>
                    <van-icon name="close" size="22" color="#EE0A24" @click="clickCloseIcon"
                              style="position: absolute; right: 15px; margin-top: 2px"
                    />
                </div>
                <van-divider style="margin-top: 0px; margin-bottom: 0px; border-color: #dddddd"/>
                <div>
<!--                    <Wp_limit_price_model ref="Wp_limit_price_model"-->
<!--                                          @getFilterData="getFilterData"-->
<!--                                          @hasFilter="hasFilter"-->
<!--                    ></Wp_limit_price_model>-->
                    <Wp_options_filter_page @getFilterData="getFilterData"
                                            @hasFilter="hasFilter"
                    ></Wp_options_filter_page>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Wp_limit_price_model from "./Wp_limit_price_model";
    import Wp_options_filter_page from "./Wp_options_filter_page";
    export default {
        name: "Wp_options_filter_model",
        components: {Wp_options_filter_page, Wp_limit_price_model},
        data(){
            return{
                showPop: false,
                has_filter: false,
            }
        },

        methods:{

            /**
             * 通过emit传递value过来，用来判断状态
             * @param value
             */
            hasFilter(value){
                this.has_filter = value;
            },

            getFilterData(filterData){
                this.$emit('getFilterData', filterData);
                this.showPop = false;
            },

            showChooseOptionsPage(){
                this.showPop = true;
            },

            clickCloseIcon(){
                this.showPop = false;

                // this.$refs.Wp_price_limit_model.reset();
                // this.$refs.Wp_price_limit_model.submit();
            }
        }
    }
</script>

<style scoped>
    .van-button {
        font-size: 12px;
        /*height: 32px !important;*/
        /*line-height: 32px !important;*/

        border-radius: 0px;
        border: 0px solid #ebedf0;
    }

    .van-button--default {
        color: #323233;
        background-color: #fff;
        border: 0px solid #ebedf0;
    }
</style>